import styled from "styled-components";
import {IconButton, Tooltip} from "@material-ui/core";
import HelpOutlineOutlinedIcon from "@material-ui/icons/HelpOutlineOutlined";
import React from "react";
import {StyledBaseProps} from "@betrue/shared/interfaces";

interface HelpProps extends StyledBaseProps {
  helpMessage: string
}

export const Help = styled((props:HelpProps) => (
  <span className={props.className}>
  <Tooltip title={props.helpMessage}>
              <span>
                <IconButton disabled={true}>
                  <HelpOutlineOutlinedIcon/>
                </IconButton>
              </span>
  </Tooltip>
  </span>
))``
